import React from 'react';
import { shape, bool } from 'prop-types';
import objectPath from 'object-path';
import { formatters } from 'ui-formatter';
import parseDate from 'date-fns/parse';
import formatDate from 'date-fns/format';
import avatarSVG from './images/avatar.svg';
import avatarSVGSecondary from './images/avatar-secondary.svg';
import { truncateLongName } from '../../utils/util';

const toMoney = value => formatters.toMoney.bind({ precision: 2, roundFn: 'round' })(value.toString());

// included in loanSummary which is a pi1 locked test
const BorrowerCard = ({ borrower, isSecondary, isSingleCard }) => {
  const address = objectPath.get(borrower, 'personalInfo.address');
  const totalIncome =
    objectPath.get(borrower, 'personalInfo.income') + (objectPath.get(borrower, 'personalInfo.additionalIncome') || 0);
  return (
    <div className={`borrower-card${isSingleCard ? ' borrower-card--single-card' : ''}`}>
      <div className="borrower-card__row borrower-card__row--avatar-name-address">
        <div className="borrower-card__avatar">
          <img alt="avatar" src={isSecondary ? avatarSVGSecondary : avatarSVG} />
        </div>
        <div className="borrower-card__group borrower-card__group--name-and-address">
          <div className="borrower-card__info borrower-card__info--name">
            <div className="borrower-card__content borrower-card__content--bold">
              {truncateLongName(borrower.firstName)} {truncateLongName(borrower.lastName)}
            </div>
          </div>
          <div className="borrower-card__info borrower-card__info--address">
            <div className="borrower-card__content">{address.street}</div>
            <div className="borrower-card__content">
              {address.city}, {address.state} {address.zip}
            </div>
          </div>
        </div>
      </div>
      <div className="borrower-card__row borrower-card__row--separator" />
      <div className="borrower-card__row borrower-card__row--income-dob">
        <div className="borrower-card__group borrower-card__group--income-and-dob">
          <div className="borrower-card__info borrower-card__info--income">
            <div className="borrower-card__title">Total Income</div>
            <div className="borrower-card__content">{toMoney(totalIncome)}</div>
          </div>
          <div className="borrower-card__info borrower-card__info--dob">
            <div className="borrower-card__title">D.O.B</div>
            <div className="borrower-card__content">{formatDate(parseDate(borrower.dateOfBirth), 'MM/DD/YYYY')}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

BorrowerCard.propTypes = {
  borrower: shape({}),
  isSecondary: bool,
  isSingleCard: bool,
};

BorrowerCard.defaultProps = {
  borrower: {},
  isSecondary: false,
  isSingleCard: false,
};

export default BorrowerCard;

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/pages/pi1-1QAAT/components/BorrowerCards/BorrowerCards.scss');